import React from 'react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { Body } from 'shared-global-ec-uikit/components/dist/react/esm/components/body'
import { Display } from 'shared-global-ec-uikit/components/dist/react/esm'
import Parser from 'html-react-parser'

type Props = {
  parkingComment: string
} & WrappedComponentProps

const StoreParking = ({ parkingComment, intl }: Props) => {
  return (
    <>
      <Display
        color="primary-dark"
        element="p"
        maxLinesEllipsis={0}
        textAlign="left"
        textTransform="normal"
        variant="display4"
        className="fr-ec-mb-spacing-04"
      >
        {intl.formatMessage({ id: `text_parking_information_title` })}
      </Display>
      <Body color="primary-dark" element="p" variant="standard">
        {Parser(parkingComment)}
      </Body>
    </>
  )
}

export default injectIntl(StoreParking)
